module.exports = __webpack_public_path__ + "img/cooler_down_code.63643e6f.png";